import {
  FieldModel,
  IntegerString,
  PracticeContentDataTypes,
  PracticeDetailFields,
  PracticeDetailTypesEntry,
} from '@cibo/core'
import { usePracticesContent } from '@cibo/landmanager/src/queries'
import { ListCell } from '@cibo/ui'
import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { useMemo } from 'react'

export const PracticesSelectedCell = (
  params: GridRenderCellParams<FieldModel, IntegerString[]>
) => {
  const selectedPractices = params.value
  const practicesContent = usePracticesContent()

  const selectedPracticesContent = useMemo(
    () =>
      selectedPractices
        ?.map(practiceId =>
          practicesContent.data?.items.find(
            practice => (practice.fields as PracticeDetailFields).practiceId === practiceId
          )
        )
        .filter(Boolean) ?? [],
    [selectedPractices, practicesContent.data]
  )

  return (
    <ListCell<PracticeDetailTypesEntry>
      isPending={practicesContent.isPending}
      listItems={selectedPracticesContent as PracticeContentDataTypes[]}
      accessor={practice => practice.fields.name}
    />
  )
}
